import { logger } from "../logger";

export function decodeJWT<T>(jwt: string) {
  const base64UrlDecode = (str: string) => {
    let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
      base64 += "=";
    }
    return atob(base64);
  };

  try {
    const parts = jwt.split(".");
    if (parts.length !== 3) {
      throw new Error("JWT does not have 3 parts!");
    }

    const header = JSON.parse(base64UrlDecode(parts[0]));
    const payload: T = JSON.parse(base64UrlDecode(parts[1]));

    return { header, payload };
  } catch (err) {
    logger.error(`Failed to decode JWT with errror: ${err}`);
    return null;
  }
}
